import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const akamaiIdentityCloudSocial = defineConnector({
  identifier: "akamaiIdentityCloudSocial",
  name: "Akamai Identity Cloud Social",
  tagLine: "Social login and identity management",
  logo,
  protocol: "http",
  tags: ["identity"],
  defaultUrlPattern: ({ socialApplicationDomain }) =>
    socialApplicationDomain
      ? `https://${socialApplicationDomain.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.rpxnow\\.com/.*",
  auth: (app) => queryAuth([{ name: "apiKey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Find your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Open your **Social Login Dashboard**, click the **Manage Settings** icon, and copy the `API Key (Secret)` value. You can also find this as `rpx_key` on the **Manage Application** page.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Social application domain",
          placeholder: "yourapp.rpxnow.com",
          required: true,
          target: { kind: "configuration", field: "socialApplicationDomain" },
          helperText:
            "Your Social Login domain (for example, yourapp.rpxnow.com).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ socialApplicationDomain }) => ({
      url: `https://${socialApplicationDomain}/api/v2/all_mappings`,
      method: "POST",
    }),
  },
});
